module.exports = __webpack_public_path__ + "img/15.20a94efb.jpg";